import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CurrentSelection, Customer, Equipment, Family, JobSite, Make, Model, SearchFavorite, SearchItem, SelectionLists } from '../../../../../app/entities';
import { AppService } from '../../../../../app/app.service';
import { TranslateService } from '../../../../../app/translate';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SetupEquipmentService } from '../../../../../app/modules/setup-equipment/setup-equipment.service';
import { PmServiceTypes, PmServiceTypesVM, UcFleet, UcPlannerDetail } from '../../../../../app/modules/setup-equipment/setup-equipment.model';
import { MatTableDataSource } from '@angular/material/table';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { UpdateSMUReadingModel } from '../../models/manage-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { InspectionForecastPreferenceModel, TRACKForcastVM } from '../../../../../app/modules/interpretation/models/interpretation.model';
import moment from 'moment';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SharedService } from '../../../../../app/shared/services/SharedService';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { ClosepmservicepopupComponent } from './closepmservicepopup/closepmservicepopup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-smu-pm-service',
  templateUrl: './smu-pm-service.component.html',
  styleUrls: ['./smu-pm-service.component.scss']
})
export class SMUPMServiceComponent implements OnInit {
  public modelList: Model[] = [];
  public modelListFilter: Model[] = [];
  public customerList: Customer[] = [];
  public customerListFliter: Customer[] = [];
  public jobSiteList: JobSite[] = [];
  public jobSiteListFilter: JobSite[] = [];
  selectedModels = [];
  userLanguage = 'english';
  JobsiteId: number;
  CustomerId: number;
  UcPlannerDetail: UcPlannerDetail[];
  showTableView: boolean = false;
  dayDiff: number;
  dayDiff1: number;
  dayDiff2: number;
  NextPMSMU: number;
  NextPmDistance: number;
  SecondPMSMU: number;
  SecondDistance: number;
  FloatingSMU: number;
  FloatingDistance: number;
  dayDiff3: number;
  FloatingSMU2: number;
  FloatingDistance2: number;
  displayedColumns = ['model', 'unitNo', 'LastDate', 'LastSMU', 'LastDOEF', 'LastDOER', 'LastDOETotal', 'LastDOEDate', 'EnterDate', 'EnterSMU', 'Forward', 'Reverse', 'Total', 'NextPm', 'SecPm', 'FloatingDate', 'FloatingDate2', 'actions'];
  @ViewChild('modelInput') modelInput: ElementRef<HTMLInputElement>;
  _minDateNextPm: Date = new Date();
  _minDateSecoundPm: Date = new Date();
  _minDateFlaotingDate1: Date = new Date();
  _minDateFlaotingDate2: Date = new Date();
  forecastDataVM: TRACKForcastVM;
  calculatedUsaghourChecked: boolean;
  hourChecked: boolean;
  Smu: number;
  Doe: number;
  EnteringDate: Date;
  PmDate: Date;
  SecondPmDate: Date;
  FloatingDate1: Date;
  FloatingDate2: Date;
  selectedModel: number[] = [];
  dataLoading: boolean;
  makeTitle: string = '';
  SmuDate: Date;
  userFavorites: SearchFavorite[] = [];
  userUOD: string = 'km';
  IsFirstTimeLoad: boolean = false;
  @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger1: MatAutocompleteTrigger;
  HasfavData: boolean
  dataSource = new MatTableDataSource<UcPlannerDetail>([]);
  constructor(private _appService: AppService,
    private _planerService: SetupEquipmentService,
    private _interp: InterpretationService,
    private _equipment: ManageEquipmentService,
    private _translate: TranslateService, private _notification: NotificationsService, private _sharedService: SharedService,
    private _pref: PreferencesService, private _dialog: MatDialog,) {

    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
    this.familyCtrl = new FormControl();
    this.makeCtrl = new FormControl();
    this.modelCtrl = new FormControl();
  }
  isTyping: { [key: string]: boolean } = {};
  ngOnInit(): void {
    this._appService.setPageTitle("Smu Pm Service");
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset(); });
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this.selectionLists.jobSiteList = result; this.internalLimitedJobSites = result; this.jobsiteCtrl.reset(); });

    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset(); });
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);
      this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();
    });

    this._appService.getUserSearchFavorites(2).subscribe(result => {
      this.userFavorites = result;
      if (this.userFavorites.length > 0) {
        this.HasfavData = true;
      }
      var checkDefaultFav = this.userFavorites.filter(f => f.isDefaultFavourite == true)
      if (checkDefaultFav.length > 0) {
        this.getFavorite(checkDefaultFav[0].Id);
      }
    }, error => console.log(error), () => { });

    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
    this.filteredJobsites = this.jobsiteCtrl.valueChanges
      .startWith(null)
      .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
    this.filteredMakes =
      this.makeCtrl.valueChanges
        .startWith(null)
        .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
    this.filteredModels =
      this.modelCtrl.valueChanges
        .startWith(null)
        .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());
    this._appService.getUserSearchFavorites(2).subscribe(result => {
      this.userFavorites = result;
      var checkDefaultFav = this.userFavorites.filter(f => f.isDefaultFavourite == true)
      if (checkDefaultFav.length > 0) {
      }
    }, error => console.log(error), () => { });
    this.getUserUOD();
    this.GetPmServiceData();
  }

  resetMake(): Make[] {
    this.currentSelection.make = new Make();
    if (!this.selectionLists.makeList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.makeList.filter(make =>
      (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
    );

  }

  resetModel(): Model[] {
    this.currentSelection.model = new Model();


    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model =>
      this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  // Remove model from selected list

  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);
      this.selectedModels.splice(index, 1);
    }
  }

  addModel(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const foundModel = this.modelList.find(model => model.Title.toLowerCase() === value.toLowerCase());
    if (foundModel && !this.selectedModels.includes(foundModel)) {
      this.selectedModels.push({ Name: value });
    }
    event.chipInput!.clear();
    this.filterModels('');
  }

  filterModels(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      );

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

  }

  selectModel(event: MatAutocompleteSelectedEvent): void {
    const model = event.option.value;
    const Id = event.option.value.Id;
    this.selectedModel.push(Id);
    if (!this.selectedModels.some(selectedModel => selectedModel.Name === model.Name)) {
      this.selectedModels.push(model);
    }
    if (this.modelInput.nativeElement != undefined) {
      this.modelInput.nativeElement.value = '';
    }
    this.filterModels('');
  }
  familyId: number;
  make_auto: number;
  ucFleet: UcFleet = new UcFleet();
  LoadUcPlannerDetail() {

    this.selectedModel = [];

    this.familyId = 0,
      this.JobsiteId = 0
    this.make_auto = 0
    this.PmDate = this.SecondPmDate = this.FloatingDate1 = this.FloatingDate2 = null;


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    if (customerData != null) {
      this.CustomerId = customerData.SearchId;
    }


    var familyData = this.multipleSelections.find(x => x.Id == 4);
    if (familyData != null) {
      if (this.familyCtrl.value != '') {
        this.familyId = familyData.SearchId;
      }
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    if (jobSiteData != null) {
      if (this.jobsiteCtrl.value != '') {
        this.JobsiteId = jobSiteData.SearchId;
      }
    }
    var makeData = this.multipleSelections.find(x => x.Id == 5);
    if (makeData != null) {
      if (this.makeCtrl.value != '') {
        this.make_auto = makeData.SearchId;
      }
    }
    var modelData = this.multipleSelections.filter(x => x.Id == 6);
    if (modelData != null) {
      modelData.forEach(element => {
        this.selectedModel.push(element.SearchId)
      });
    }
    if (this.CustomerId > 0) {
      if (this.JobsiteId > 0) {
        if (!this.IsFirstTimeLoad) {
          this.dataLoading = true;
          this.showTableView = false;
        }


        this.ucFleet.CustomerId = this.CustomerId;
        this.ucFleet.FamilyId = this.familyId == 0 ? null : this.familyId;
        this.ucFleet.Jobsiteid = this.JobsiteId == 0 ? null : this.JobsiteId;
        this.ucFleet.MakeId = this.make_auto == 0 ? null : this.make_auto;
        this.ucFleet.Modelid = this.selectedModel == null || this.selectedModel.length == 0 ? null : this.selectedModel.join(',');
        this._planerService.getUcPlannerDetail(this.ucFleet).subscribe(result => {
          this.UcPlannerDetail = result;

          this.UcPlannerDetail.forEach(x => {
            x.IsEstimated=false;
            x.ReverseDistanceSave = null,
              x.ForwardDistanceSave = null
          })
          if (this.SmuDate != null) {
            this.SmuDateChange();
          }
          this.dataSource.data = result;

          if (!this.IsFirstTimeLoad) {
            this.showTableView = true;
            this.dataLoading = false;
          }
          this.IsFirstTimeLoad = true;
        });
      } else {
        this._notification.warn('Select jobsite.')
      }
    } else {
      this._notification.warn('Select customer.')
    }
  }
  InspectionForecastPreferenceModel: InspectionForecastPreferenceModel = new InspectionForecastPreferenceModel();
  GetActionType: number;
  GetForecastPreference(inspectionId) {
    this._interp.GetForecastPreference(inspectionId).subscribe(result => {
      this.InspectionForecastPreferenceModel = result;
      this.GetActionType = this.InspectionForecastPreferenceModel.ActionTypeId;
      //this.getDailyUsagehoursAndDailyDistance()
    });
  }
  PmServiceTypesVM: PmServiceTypesVM;
  PmServiceTypes: PmServiceTypes[] = [];
  GetPmServiceData() {
    this._planerService.GetPmServiceTypes().subscribe(result => {
      if (result != null) {
        this.PmServiceTypes = result.Data;
        console
        this.PmServiceTypesVM = result;
      }
    });
  }
IsSaveClick: boolean = false;
  updateMeterClicked(equiptmentData: UcPlannerDetail): void {
this.IsSaveClick = true;
    this.getDailyUsagehoursAndDailyDistance(null, null, equiptmentData);

  }

  SavereadingData(equiptmentData: UcPlannerDetail) {
    // equiptmentData.loading = true;
    let updateModel = new UpdateSMUReadingModel();
    updateModel.currentReading = equiptmentData.EnterSmu;
    // updateModel.currentDistanceReading = equiptmentData.EnterDoe;
    updateModel.ForwardDistance = this.convertDistanceMiToKm(equiptmentData.ForwardDistanceSave);
    updateModel.ReverseDistance = this.convertDistanceMiToKm(equiptmentData.ReverseDistanceSave);
    updateModel.dateReadSMU = this.getFormatedDate(new Date(equiptmentData.DateEnter));// this.getFormatedDate(this.dateOfReading);//this.dateOfReading.toDateString();
    updateModel.equipmentId = equiptmentData.Id;
     updateModel.IsEstimatedDistance = equiptmentData.IsEstimated;
    
    if (equiptmentData.EnterSmu != null || equiptmentData.EnterSmu > 0 || equiptmentData.EnterDoe != null || equiptmentData.EnterDoe > 0) {
      this._equipment.changeSMUReading(updateModel).subscribe(succeeded => {
        if (succeeded.m_Item1) {
          if (this.forecastDataVM != undefined && this.forecastDataVM != null) {
            if (equiptmentData.NextPmDate != null) {
              this.CalculateForecast(1, equiptmentData.NextPmDate, equiptmentData)
            }
            if (equiptmentData.SecondPmDate != null) {
              this.CalculateForecast(2, equiptmentData.SecondPmDate, equiptmentData)
            }
            if (equiptmentData.FloatingDate1 != null) {
              this.CalculateForecast(3, equiptmentData.FloatingDate1, equiptmentData)
            }
            if (equiptmentData.FloatingDate2 != null) {
              this.CalculateForecast(4, equiptmentData.FloatingDate2, equiptmentData)
            }

        this.onSubmit(equiptmentData.InspectionId, equiptmentData.NextPmDate, equiptmentData.SecondPmDate, equiptmentData.FloatingDate1, equiptmentData.FloatingDate2, equiptmentData.PmServiceNextPmDate, equiptmentData.PmServiceSecondPmDate, equiptmentData.PmServiceFloatingDate1, equiptmentData.PmServiceFloatingDate2,equiptmentData.DistanceRatio)

          } else {
            this.LoadUcPlannerDetail();
            this._notification.success('Data Saved Successfully.');
          }
          equiptmentData.loading = false;
        } else {
          console.log(succeeded.m_Item2);
          equiptmentData.loading = false;
          this._notification.error('Error', succeeded.m_Item2);
        }
      });
    } else {
      if (this.forecastDataVM != undefined && this.forecastDataVM != null) {
        if (equiptmentData.NextPmDate != null) {
          this.CalculateForecast(1, equiptmentData.NextPmDate, equiptmentData)
        }
        if (equiptmentData.SecondPmDate != null) {
          this.CalculateForecast(2, equiptmentData.SecondPmDate, equiptmentData)
        }
        if (equiptmentData.FloatingDate1 != null) {
          this.CalculateForecast(3, equiptmentData.FloatingDate1, equiptmentData)
        }
        if (equiptmentData.FloatingDate2 != null) {
          this.CalculateForecast(4, equiptmentData.FloatingDate2, equiptmentData)
        }

        this.onSubmit(equiptmentData.InspectionId, equiptmentData.NextPmDate, equiptmentData.SecondPmDate, equiptmentData.FloatingDate1, equiptmentData.FloatingDate2, equiptmentData.PmServiceNextPmDate, equiptmentData.PmServiceSecondPmDate, equiptmentData.PmServiceFloatingDate1, equiptmentData.PmServiceFloatingDate2,equiptmentData.DistanceRatio)

      } else {
        this.onSubmit(equiptmentData.InspectionId, equiptmentData.NextPmDate, equiptmentData.SecondPmDate, equiptmentData.FloatingDate1, equiptmentData.FloatingDate2, equiptmentData.PmServiceNextPmDate, equiptmentData.PmServiceSecondPmDate, equiptmentData.PmServiceFloatingDate1, equiptmentData.PmServiceFloatingDate2, equiptmentData.DistanceRatio)
        this.LoadUcPlannerDetail();
        this._notification.success('Data Saved Successfully.');
      }

    }
  }

  getFormatedDate = (currentDate) => {
    console.log("date", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  getDailyUsagehoursAndDailyDistance(value?, date?, element?) {
   
    this.GetForecastPreference(element.InspectionId);
    this._interp.getDailyUsageHoursAndDistance(element.InspectionId).subscribe(result => {
      this.forecastDataVM = result;
      if (this.forecastDataVM.ForecastMethod != "" && this.forecastDataVM.ForecastMethod != null) {
        if (this.forecastDataVM.ForecastMethod == "Hours") {
          this.hourChecked = true;

        } else {
          this.hourChecked = false;
        }
      }
      else {
        this.hourChecked = true;
      }
      if (this.forecastDataVM.DailyUsageCalculationMethod != "" && this.forecastDataVM.DailyUsageCalculationMethod != null) {
        if (this.forecastDataVM.DailyUsageCalculationMethod == "calculated") {
          this.calculatedUsaghourChecked = true;
        } else {
          this.calculatedUsaghourChecked = false;
        }
      } else {
        this.calculatedUsaghourChecked = true;
      }

      this.CalculateForecast(value, date, element);
      if(this.IsSaveClick){
      this.SavereadingData(element);
      }
    });
  }

  onNextPmDateChange(value: number, date: Date, element: UcPlannerDetail) {
    this.getDailyUsagehoursAndDailyDistance(value, date, element)
  }

  CalculateForecast(value, date, element) {
    if (this.GetActionType == 41) {
      if (value == 1) {
        if (element.NextPmDate != null) {
          this._minDateSecoundPm = date;
          const start = new Date(element.DateEnter).getTime();
          const end = new Date(element.NextPmDate).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));

          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+element.EnterSmu);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+element.ForwardDistanceSave + (+element.ReverseDistanceSave));
          }
          else {
            this.NextPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff) + (+element.EnterSmu);
            this.NextPmDistance = (this.forecastDataVM.DailyUsageHours * this.dayDiff) + (+element.ForwardDistanceSave + (+element.ReverseDistanceSave));
          }
        }

      } else if (value == 2) {
        this._minDateFlaotingDate1 = date;
        if (element.NextPmDate != null && element.SecondPmDate != null) {

          let startdate = element.NextPmDate;
          let endDate = element.SecondPmDate;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
          }
          else {
            this.SecondPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.DailyUsageHours * this.dayDiff1) + (+this.NextPmDistance);
          }
        }
      } else if (value == 3) {
        this._minDateFlaotingDate2 = date;
        if (element.SecondPmDate != null && element.FloatingDate1 != null) {
          const start = new Date(element.SecondPmDate).getTime();
          const end = new Date(element.FloatingDate1).getTime();
          const diff = end - start;
          if (element.FloatingDate1 != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondDistance);
          }
        }
      } else {
        if (element.FloatingDate1 != null && element.FloatingDate2 != null) {
          const start = new Date(element.FloatingDate1).getTime();
          const end = new Date(element.FloatingDate2).getTime();
          const diff = end - start;
          if (element.FloatingDate2 != null) {
            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingDistance);
          }
        }
      }
    } else {
      if (value == 1) {
        if (element.NextPmDate != null) {
          this._minDateSecoundPm = date;
          const start = new Date(element.LastInspectionDate).getTime();
          const end = new Date(element.NextPmDate).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));

          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
          }
          else {
            this.NextPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.DailyUsageHours * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
          }
        }

      } else if (value == 2) {
        this._minDateFlaotingDate1 = date;
        if (element.NextPmDate != null && element.SecondPmDate != null) {

          let startdate = element.NextPmDate;
          let endDate = element.SecondPmDate;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
          }
          else {
            this.SecondPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.DailyUsageHours * this.dayDiff1) + (+this.NextPmDistance);
          }
        }
      } else if (value == 3) {
        this._minDateFlaotingDate2 = date;
        if (element.SecondPmDate != null && element.FloatingDate1 != null) {
          const start = new Date(element.SecondPmDate).getTime();
          const end = new Date(element.FloatingDate1).getTime();
          const diff = end - start;
          if (element.FloatingDate1 != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondDistance);
          }
        }
      } else {
        if (element.FloatingDate1 != null && element.FloatingDate2 != null) {
          const start = new Date(element.FloatingDate1).getTime();
          const end = new Date(element.FloatingDate2).getTime();
          const diff = end - start;
          if (element.FloatingDate2 != null) {
            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingDistance);
          }
        }
      }
    }

  }

  onSubmit(inspectionid, nexpmDate, secondpmDate, Floatingdate1, FloatingDate2, pmserviceNextPm, pmserviceSecondPm, pmserviceFloating1Pm, pmserviceFloating2, distanceRatio) {

    var foreCastData = new TRACKForcastVM();
    foreCastData.InspectionId = inspectionid;
    foreCastData.DailyUsageHours = this.forecastDataVM.DailyUsageHours;
    foreCastData.DailyUageDistance = this.convertDistanceMiToKm(this.forecastDataVM.DailyUageDistance);
    foreCastData.ForecastMethod = this.hourChecked ? "Hours" : "Distance";
    foreCastData.PmNextDateService = nexpmDate != null ? new Date(nexpmDate) : null;
    foreCastData.PmNextDateServiceString = nexpmDate != null ? moment(nexpmDate).format('MM/DD/YYYY') : null;
    foreCastData.SecondPmNextDateService = secondpmDate != null ? new Date(secondpmDate) : null;
    foreCastData.SecondPmNextDateServiceString = secondpmDate != null ? moment(secondpmDate).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate = Floatingdate1 != null ? new Date(Floatingdate1) : null;
    foreCastData.FloatingDateString = Floatingdate1 != null ? moment(Floatingdate1).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate2 = FloatingDate2 != null ? new Date(FloatingDate2) : null;
    foreCastData.FloatingDateString2 = FloatingDate2 != null ? moment(FloatingDate2).format('MM/DD/YYYY') : null;
    foreCastData.PmNextDateServiceSMU = +this.NextPMSMU;
    foreCastData.PmNextDateServiceDOE = this.convertDistanceMiToKm(+this.NextPmDistance);
    foreCastData.SecondPmNextDateServiceSMU = +this.SecondPMSMU;
    foreCastData.SecondPmNextDateServiceDOE = this.convertDistanceMiToKm(+this.SecondDistance);
    foreCastData.FloatingSMU = +this.FloatingSMU;
    foreCastData.FloatingDOE = this.convertDistanceMiToKm(+this.FloatingDistance);
    foreCastData.FloatingSMU2 = +this.FloatingSMU2;
    foreCastData.FloatingDOE2 = this.convertDistanceMiToKm(+this.FloatingDistance2);
    foreCastData.PmNextServiceType = pmserviceNextPm;
    foreCastData.PmSecondServiceType = pmserviceSecondPm;
    foreCastData.FloatingDate1ServiceType = pmserviceFloating1Pm;
    foreCastData.FloatingDate2ServiceType = pmserviceFloating2;
    foreCastData.DistanceRatio = distanceRatio;

    if (foreCastData.PmNextDateServiceString != null && foreCastData.PmNextDateServiceString != "") {
      if (pmserviceNextPm == null || pmserviceNextPm == "") {
        this._notification.warn('Please select service type for Next PM Date.');
        return;
      }
    }
    if (foreCastData.SecondPmNextDateServiceString != null && foreCastData.SecondPmNextDateServiceString != "") {
      if (pmserviceSecondPm == null || pmserviceSecondPm == "") {
        this._notification.warn('Please select service type for Second PM Date.');
        return;
      }
    }
    if (foreCastData.FloatingDateString != null && foreCastData.FloatingDateString != "") {
      if (pmserviceFloating1Pm == null || pmserviceFloating1Pm == "") {
        this._notification.warn('Please select service type for Floating Date 1.');
        return;
      }
    }
    if (foreCastData.FloatingDateString2 != null && foreCastData.FloatingDateString2 != "") {
      if (pmserviceFloating2 == null || pmserviceFloating2 == "") {
        this._notification.warn('Please select service type for Floating Date 2.');
        return;
      }
    }
    foreCastData.DailyUsageCalculationMethod = this.calculatedUsaghourChecked == true ? "calculated" : "manually";
    this._interp.SaveForeCastData(foreCastData).subscribe(
      res => {
        if (res == 1) {
          this.LoadUcPlannerDetail();
          this.IsSaveClick = false;
          this._notification.success('Success', 'Data saved successfully');
        }
      },
      error => {
        this._notification.error('Error saving data', 'Failed to save the record');
      }
    );
  }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.customerListFliter = this.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    } else {
    }
  }
  customerTitle: string;
  onSelectCustomer(event: any) {
    let id = this.customerListFliter.find(f => f.Title.trim() == event.value.trim()).Id;
    this.CustomerId = id;
    this.customerTitle = event.value;
    this.jobSiteListFilter = this.jobSiteList.filter(jobsite =>
      jobsite.CustomerId == id);
    this.autoCompleteTrigger1.closePanel();
    this.autoCompleteTrigger1.writeValue('');
  }

  SmuDateChange() {
    this.UcPlannerDetail.forEach(element => {
      element.DateEnter = this.SmuDate;
    });
  }
  @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger: MatAutocompleteTrigger;
  showConfirm: boolean

  resetFields() {
    if (this.UcPlannerDetail != null) {

      const hasEnterDate = this.UcPlannerDetail.some(item => !!item.DateEnter);
      if (hasEnterDate)
        this.showConfirm = true;

    }
    this.confirmClear()
    this.UcPlannerDetail = [];
  }
  isPastDate(date: any): boolean {
    if (!date) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // clear time for accurate comparison
    const inputDate = new Date(date);
    return inputDate < today;
  }
  confirmClear() {

    this.customerTitle = "";
    this.selectedModels = [];
    this.JobsiteId = 0;
    this.showTableView = false;
    this.UcPlannerDetail = [];
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
    this.multipleSelections = [];
    this.selectedModel = [];
    this.showConfirm = false;
  }

  cancelClear() {
    this.showConfirm = false;
  }

  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  selectedComponentType: number = 0;
  familyCtrl: FormControl;
  makeCtrl: FormControl;
  modelCtrl: FormControl;


  @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
  makeTrigger: MatAutocompleteTrigger;
  @ViewChild('familyAutoCompleteInput', { read: MatAutocompleteTrigger })
  familyTrigger: MatAutocompleteTrigger;
  @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
  modelTrigger: MatAutocompleteTrigger;
  @ViewChild('examinerAutoCompleteInput', { read: MatAutocompleteTrigger })
  examinerTrigger: MatAutocompleteTrigger;
  @ViewChild('dealerAutoCompleteInput', { read: MatAutocompleteTrigger })
  dealerTrigger: MatAutocompleteTrigger;

  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;
      case 4:
        this.familyTrigger.openPanel();
        break;
      case 5:
        this.makeTrigger.openPanel();
        break;
      case 6:
        this.modelTrigger.openPanel();
        break;
      case 20:
        this.examinerTrigger.openPanel();
        break;
      case 21:
        this.dealerTrigger.openPanel();
        break;
    }
  }
  selectionLists: SelectionLists = new SelectionLists();
  selectedJobsiteForInput: JobSite = new JobSite();
  currentSelection: CurrentSelection = new CurrentSelection();

  customerDisplayMapper(customer: Customer) {
    return customer ? customer.Title : customer;
  }
  jobsiteDisplayMapper(jobsite: JobSite) {
    return jobsite ? jobsite.Title : jobsite;
  }
  JobSiteforFleetconfiguration: JobSite = new JobSite()

  internalLimitedJobSites: JobSite[];
  internalLimitedEquipments: Equipment[];
  internalLimitedModels: Model[];
  internalLimitedCustomers: Customer[];
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];

  getPushedSelections(itemId): SearchItem[] {
    let arr = this.multipleSelections.filter(m => m.Id === itemId);

    return arr
  }
  resetFamily(): Family[] {
    // console.log('resetFamily', this.selectionLists.familyList);
    this.currentSelection.family = new Family();
    if (!this.selectionLists.familyList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.familyList.filter(family =>
      (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
    );
  }
  resetJobsite(): JobSite[] {
    // console.log('resetJobsite', this.internalLimitedJobSites);
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }
  filterMakes(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.makeList.filter(make =>
      (make.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
    );
  }
  filterFamilies(userText: any) {
    // console.log('filterFamilies', this.selectionLists.familyList);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.familyList.filter(family =>
      family.Title.toLowerCase().indexOf(txt.toLowerCase())
    );
  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust =>
      cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  filteredCustomers: Observable<Customer[]>;
  filteredJobsites: Observable<JobSite[]>;
  filteredEquipments: Observable<Equipment[]>;
  filteredFamilies: Observable<Family[]>;
  filteredMakes: Observable<Make[]>;
  filteredModels: Observable<Model[]>;
  filteredExaminers: Observable<Customer[]>;
  filteredDealer: Observable<Customer[]>;
  filterMakeModelFamilyForExistingOnly = true;
  jobsiteSelected(selected, input) {
    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
    }

    this._appService.getFamilyList(customerid.toString(), jobsiteid.toString()).subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());

    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);
  }
  DistanceSum(element) {

  }
  customerSelected(selected, input) {

    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    //this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }

  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }
  }

  resetCustomer(): Customer[] {
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();

    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


  }
  popMultipleSelection(itemId: number, searchId: number, searchText: string) {
    console.log("searchId", searchId, searchText.length)
    if (searchId === 0 && searchText.length === 0)
      return;
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;
    const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
    if (index < 0) return;
    this.multipleSelections.splice(index, 1);
    this.resetControlBySearchId(itemId);

  }
  resetControlBySearchId(itemId: number): void {
    switch (itemId) {
      case 1: // 1 -> Customer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        break;
      case 2: // 2 -> Jobsite
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        break;
      case 3: // 3 -> Equpment
        this.equipmentCtrl.reset();
        break;
      case 4: // 4 -> Family
        this.familyCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 5: // 5 -> Make
        this.makeCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 6: // 6 -> Model
        this.modelCtrl.reset();
        break;
      case 20: // 20 -> Examiner
        break;
      case 21: // 21 -> Dealer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
    }
  }

  familySelected(selected, input) {
    this.currentSelection.family.Id = selected.option.value.Id;
    this.currentSelection.family.Title = selected.option.value.Title;
    this.pushMultipleSelection(4, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.familyCtrl.reset();
    this.familyCtrl.setValue(selected.option.value.Title);
  }

  makeSelected(selected, input) {


    this.currentSelection.make.Id = selected.option.value.Id;
    this.currentSelection.make.Title = selected.option.value.Title;

    this.pushMultipleSelection(5, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 4).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.makeCtrl.reset();
    this.makeCtrl.setValue(selected.option.value.Title)
  }
  separatorKeysCodes: number[] = [ENTER, COMMA];
  modelDisplayMapper(model: Model) {
    return model ? model.Title : model;
  }

  modelSelected(selected, input) {
    if (input)
      input.value = '';
    this.currentSelection.model.Id = selected.option.value.Id;
    this.currentSelection.model.Title = selected.option.value.Title;
    this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
    this.modelCtrl.reset();
  }

  getFavorite(favId: number) {
    this._appService.getFavoriteItems(favId).subscribe(result => {
      this.resetSelection();
      this.multipleSelections.push(...result);
      this.submitSelection();
    }, error => console.error(error));
  }

  resetSelection() {
    this.multipleSelections = [
      { Id: 8, SearchId: 1, SearchStr: '', Title: 'Evaluation A' },
      { Id: 9, SearchId: 1, SearchStr: '', Title: 'Evaluation B' },
      { Id: 10, SearchId: 1, SearchStr: '', Title: 'Evaluation C' },
      { Id: 11, SearchId: 1, SearchStr: '', Title: 'Evaluation X' },
    ];
    this.filteredCustomers = Observable.of(this.selectionLists.customerList);
    this.filteredJobsites = Observable.of(this.selectionLists.jobSiteList);
    this.filteredFamilies = Observable.of(this.selectionLists.familyList);
    this.filteredMakes = Observable.of(this.selectionLists.makeList);
    this.filteredModels = Observable.of(this.selectionLists.modelList);
    this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
    this.filteredExaminers = Observable.of(this.selectionLists.examinerList);
    this.filteredDealer = Observable.of(this.selectionLists.dealerList);

    this.internalLimitedJobSites = this.selectionLists.jobSiteList;
    this.internalLimitedModels = this.selectionLists.modelList;
    this.internalLimitedEquipments = this.selectionLists.equipmentList;
    this.selectedComponentType = 0;

    this.internalLimitedCustomers = this.selectionLists.customerList;
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
    this.multipleSelections = [];
    this.selectedModel = [];
  }


  submitSelection(): void {
    this.currentSelection = new CurrentSelection();
    const firstCustomer = this.multipleSelections.find(m => m.Id === 1);
    if (firstCustomer) {
      this.currentSelection.customer.Id = firstCustomer.Id;
      this.currentSelection.customer.Title = firstCustomer.Title;
      this.customerCtrl.setValue(firstCustomer.Title)
      this.CustomerId = firstCustomer.Id;
    }

    const firstJobsite = this.multipleSelections.find(m => m.Id === 2);
    if (firstJobsite) {
      this.currentSelection.jobSite.Id = firstJobsite.Id;
      this.currentSelection.jobSite.Title = firstJobsite.Title;
      this.jobsiteCtrl.setValue(firstJobsite.Title)
      this.JobsiteId = firstJobsite.Id;
    }

    const firstFamily = this.multipleSelections.find(m => m.Id === 4);
    if (firstFamily) {
      this.currentSelection.family.Id = firstFamily.Id;
      this.currentSelection.family.Title = firstFamily.Title;
      this.familyCtrl.setValue(firstFamily.Title)
      this.familyId = firstFamily.Id;
    }
    const firstMake = this.multipleSelections.find(m => m.Id === 5);
    if (firstMake) {
      this.currentSelection.make.Id = firstMake.Id;
      this.currentSelection.make.Title = firstMake.Title;

      this.makeCtrl.setValue(firstFamily.Title)
      this.make_auto = firstFamily.Id;
    }
    const firstModel = this.multipleSelections.find(m => m.Id === 6);
    if (firstModel) {
      this.currentSelection.model.Id = firstModel.Id;
      this.currentSelection.model.Title = firstModel.Title;
    }
  }
  //TT-9235
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
  //to save values in KM when user preferance is in miles
  convertDistanceMiToKm(val: number): number {
    return this.userUOD === 'km' ? val : Math.round(val * 1.60934);
  }

  ClosePmService(item: UcPlannerDetail) {
    // this.CustomerId = this.multipleSelections.find(x => x.Id == 1).SearchId;

    const dialogRef = this._dialog.open(ClosepmservicepopupComponent, {
      width: "400px",
      data: {
        element: item,
      }

    });
    dialogRef.afterClosed().subscribe(r => {
      if (r == true) {
        this.LoadUcPlannerDetail();
      }
    });
  }

  calculateDistance(element: any) {
  
  const enteredSmu = Number(element.EnterSmu);
  const lastKnownSmu = Number(element.LastKnownSmu);

  if (!enteredSmu || !lastKnownSmu) {
    return;
  }
  const totalDistance = Number(element.ForwardDistance) + Number(element.ReverseDistance);
  const SmuDifference = Math.abs(enteredSmu - lastKnownSmu);
  const estimatedDistance = SmuDifference * Number(element.DistanceRatio);

  // Forward Distance`
 element.ForwardDistanceSave = element.ForwardDistance
    ? (Math.floor((+element.ForwardDistance / totalDistance) * estimatedDistance)+ element.ForwardDistance)
    : 0;

  // Reverse Distance
  element.ReverseDistanceSave = element.ReverseDistance
    ? (Math.floor((+element.ReverseDistance / totalDistance) * estimatedDistance)+ element.ReverseDistance)
    : 0;
    element.IsEstimated = true;

}

markManualEntry(element: any) {
  element.IsEstimated = false;
}

}
